var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _g3, _path11, _rect2, _path12, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _path17, _path18, _g7, _path19, _rect3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse, _ellipse2, _ellipse3, _path29, _rect4, _rect5, _rect6, _ellipse4, _path30, _ellipse5, _path31, _g8, _path32, _path33, _g9, _path34;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 268,
    viewBox: "0 0 438 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 268,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 35,
    width: 403,
    height: 233
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.552 117.889L206.889 98.3848H179.141L178.482 117.741C178.452 118.653 177.81 119.437 176.923 119.659C172.736 120.702 170.516 121.066 170.516 121.066C170.516 121.066 172.385 135.827 193.981 135.827C215.579 135.827 216.625 122.188 216.625 122.188C216.625 122.188 212.697 120.84 209.031 119.783C208.178 119.537 207.582 118.775 207.552 117.889",
    fill: "#FFB69C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.713 99.4688C173.428 100.9 170.653 96.3663 169.715 94.4286C168.035 90.9633 169.317 86.986 171.002 86.144C172.544 85.3737 174.147 86.3688 174.147 86.3688C174.147 86.3688 176.882 88.9419 177.517 94.3848C177.897 97.6413 176.713 99.4688 176.713 99.4688",
    fill: "#FFB594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.319 99.4688C212.604 100.9 215.379 96.3663 216.317 94.4286C217.996 90.9633 216.715 86.986 215.029 86.144C213.488 85.3737 211.885 86.3688 211.885 86.3688C211.885 86.3688 209.15 88.9419 208.515 94.3848C208.135 97.6413 209.319 99.4688 209.319 99.4688",
    fill: "#FFB594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.271 64.1113C178.275 64.1113 171.13 75.0911 173.581 89.2955C174.784 96.2765 174.739 96.1385 176.329 103.088C177.051 106.247 183.854 116.515 193.346 116.515C202.22 116.515 208.657 106.499 209.378 103.268C210.897 96.4591 210.982 96.3044 211.902 89.2955C213.782 75.0042 207.209 64.1113 193.213 64.1113H192.271Z",
    fill: "#FFC6A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.313 116.951C188.477 116.951 184.567 114.349 182.139 112.165C181.971 112.015 181.958 111.757 182.108 111.59C182.26 111.423 182.518 111.409 182.684 111.56C185.006 113.647 188.736 116.137 193.313 116.137C197.808 116.137 201.446 113.473 203.707 111.239C203.867 111.08 204.126 111.082 204.284 111.242C204.442 111.403 204.44 111.66 204.281 111.819C201.91 114.16 198.084 116.951 193.313 116.951",
    fill: "#DB836E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.18 64.4399H192.239C192.073 64.4399 191.939 64.3059 191.939 64.1409C191.939 63.9758 192.073 63.8419 192.239 63.8419H193.18C193.345 63.8419 193.479 63.9758 193.479 64.1409C193.479 64.3059 193.345 64.4399 193.18 64.4399",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.052 92.5625C185.752 92.5625 185.508 92.3193 185.508 92.0195C185.508 91.0276 184.937 90.1903 184.262 90.1903C183.586 90.1903 183.015 91.0276 183.015 92.0195C183.015 92.3193 182.772 92.5625 182.472 92.5625C182.172 92.5625 181.928 92.3193 181.928 92.0195C181.928 90.4112 182.975 89.1035 184.262 89.1035C185.548 89.1035 186.596 90.4112 186.596 92.0195C186.596 92.3193 186.352 92.5625 186.052 92.5625",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.731 92.5625C202.432 92.5625 202.187 92.3193 202.187 92.0195C202.187 91.0276 201.617 90.1903 200.941 90.1903C200.266 90.1903 199.695 91.0276 199.695 92.0195C199.695 92.3193 199.451 92.5625 199.151 92.5625C198.852 92.5625 198.607 92.3193 198.607 92.0195C198.607 90.4112 199.655 89.1035 200.941 89.1035C202.228 89.1035 203.275 90.4112 203.275 92.0195C203.275 92.3193 203.031 92.5625 202.731 92.5625",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.927 99.2104H191.725C191.5 99.2104 191.318 99.0278 191.318 98.8029C191.318 98.5781 191.5 98.3955 191.725 98.3955H194.509L194.267 89.1292C194.264 89.0511 194.284 88.9745 194.325 88.9084L196.151 85.8768C196.267 85.6838 196.518 85.6224 196.71 85.738C196.903 85.8536 196.965 86.104 196.849 86.297L195.084 89.2265L195.335 98.7926C195.338 98.9026 195.296 99.0087 195.219 99.0868C195.142 99.1657 195.037 99.2104 194.927 99.2104",
    fill: "#DB836E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.746 108.858H191.496C191.271 108.858 191.088 108.675 191.088 108.45C191.088 108.226 191.271 108.043 191.496 108.043H194.746C194.971 108.043 195.154 108.226 195.154 108.45C195.154 108.675 194.971 108.858 194.746 108.858",
    fill: "#DB836E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.48 102.762L187.721 102.775C187.721 102.775 189.119 105.788 193.033 105.788C196.945 105.788 198.48 102.762 198.48 102.762",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.45 103.181C189.049 103.997 190.446 105.38 193.034 105.38C195.619 105.38 197.082 103.995 197.724 103.17L188.45 103.181ZM193.034 106.195C188.907 106.195 187.413 103.079 187.352 102.946C187.294 102.82 187.304 102.673 187.378 102.556C187.453 102.439 187.582 102.367 187.721 102.367L198.48 102.354H198.481C198.623 102.354 198.754 102.427 198.829 102.548C198.903 102.668 198.909 102.819 198.845 102.945C198.777 103.078 197.15 106.195 193.034 106.195V106.195Z",
    fill: "#DB836E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.291 74.5217C176.342 78.4392 176.505 82.3814 176.224 83.3924C176.148 83.6627 175.045 85.413 175.045 85.413L174.117 92.1508C174.117 92.1508 171.598 83.2617 170.938 68.8883C170.86 67.2058 171.859 65.6533 173.43 65.0449C174.718 64.5466 176.51 63.8042 178.855 62.7294C187.485 58.7736 194.356 59.0025 194.356 59.0025C212.194 59.2162 215.194 71.585 213.026 84.5773C212.568 87.3139 212.258 89.1215 211.566 92.1508L210.26 85.413L208.47 83.4411C208.47 83.4411 208.294 79.2373 207.41 74.5392L177.291 74.5217Z",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.86 87.0494C178.635 87.0494 178.423 86.9075 178.346 86.6818C178.248 86.398 178.401 86.0886 178.685 85.9921L180.412 85.4029C180.474 85.3805 180.541 85.3702 180.609 85.3742C182.462 85.4475 187.564 85.4714 188.927 84.7052C189.19 84.5569 189.521 84.6509 189.667 84.9117C189.814 85.1732 189.722 85.5049 189.46 85.6516C187.652 86.6683 181.742 86.5024 180.668 86.4634L179.036 87.0199C178.978 87.0399 178.919 87.0494 178.86 87.0494",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.463 87.0491C206.405 87.0491 206.346 87.0395 206.287 87.0196L204.652 86.4614C203.85 86.4806 198.725 86.5723 196.457 85.9248C196.169 85.8427 196.001 85.5413 196.083 85.2534C196.166 84.9656 196.468 84.7981 196.756 84.8803C199.006 85.5229 204.663 85.3754 204.721 85.373C204.785 85.3746 204.851 85.3818 204.911 85.4025L206.638 85.9918C206.922 86.0883 207.075 86.3977 206.977 86.6815C206.9 86.9072 206.689 87.0491 206.463 87.0491",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.892 125.768C152.892 125.768 165.056 143.5 150.828 171.943C143.486 185.494 127.882 208.25 120.153 207.615C113.257 207.05 112.077 185.734 115.634 176.435C119.191 167.136 134.449 144.279 134.449 144.279C134.449 144.279 143.041 127.956 152.892 125.768",
    fill: "#FFB594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.014 189.898C127.014 189.898 125.751 181.66 112.944 174.484C94.4813 164.141 76.6633 147.516 76.6633 147.516C76.6633 147.516 69.2679 139.082 64.2377 139.8C59.2059 140.518 53.8997 139.355 50.3053 137.918C46.7117 136.481 48.1404 142.717 59.4364 144.41C52.5651 147.14 44.0929 147.14 39.9505 144.881C35.6597 142.541 38.5147 153.658 47.8588 156.172C57.2013 158.687 68.7798 158.727 68.7798 158.727C68.7798 158.727 102.635 207.51 117.223 207.923C131.811 208.336 127.014 189.898 127.014 189.898",
    fill: "#FFC6A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1455 153.832C48.3924 153.832 44.3369 152.506 42.0244 150.559C41.6264 150.309 40.918 150.008 40.6883 150.15C40.6125 150.197 40.5846 150.357 40.6117 150.588C40.6301 150.745 40.5176 150.888 40.3605 150.906C40.1961 150.928 40.0605 150.812 40.0414 150.655C39.9847 150.174 40.0996 149.84 40.3836 149.662C41.0026 149.272 42.1417 149.956 42.3635 150.097C45.8557 153.034 53.3636 154.511 57.4972 151.976C61.859 149.301 65.3417 149.291 67.4978 149.753C69.8502 150.256 71.1504 151.394 71.2055 151.442C71.3235 151.547 71.3347 151.728 71.2294 151.846C71.1241 151.965 70.9438 151.976 70.8234 151.871C70.6224 151.693 65.7884 147.566 57.7979 152.466C56.2464 153.417 54.2426 153.832 52.1455 153.832",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5594 149.099C47.0148 149.099 43.7307 148.613 40.5583 146.728C40.1276 146.392 39.3522 145.961 38.9669 146.137C38.7189 146.251 38.6511 146.649 38.6383 146.964C38.6319 147.122 38.4995 147.248 38.34 147.239C38.1804 147.232 38.0576 147.098 38.0648 146.94C38.0927 146.249 38.316 145.803 38.7276 145.615C39.5564 145.237 40.7498 146.15 40.883 146.256C47.164 149.983 53.9204 148.015 53.989 147.994C54.1382 147.947 54.3001 148.034 54.3464 148.186C54.3926 148.338 54.3057 148.498 54.1541 148.543C54.1182 148.554 52.2516 149.099 49.5594 149.099",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6573 151.486C47.8511 151.486 44.1043 150.893 40.7213 148.406C40.5219 148.279 40.0066 148.038 39.7649 148.168C39.6101 148.253 39.5782 148.526 39.5782 148.739C39.5782 148.898 39.4498 149.026 39.2911 149.026C39.1323 149.026 39.0039 148.898 39.0039 148.739C39.0039 148.201 39.1682 147.84 39.4905 147.664C40.0935 147.336 40.9519 147.872 41.0468 147.933C47.2775 152.512 54.7654 150.46 54.8388 150.439C54.9944 150.395 55.1507 150.485 55.1938 150.637C55.2369 150.789 55.1491 150.948 54.996 150.991C54.9593 151.002 53.1924 151.486 50.6573 151.486",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.75 125.768C230.75 125.768 218.585 143.5 232.813 171.943C240.155 185.494 255.759 208.25 263.488 207.615C270.384 207.05 271.564 185.734 268.007 176.435C264.45 167.136 249.192 144.279 249.192 144.279C249.192 144.279 240.6 127.956 230.75 125.768",
    fill: "#FFB594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.626 189.898C256.626 189.898 257.889 181.66 270.696 174.484C289.159 164.141 306.977 147.516 306.977 147.516C306.977 147.516 314.372 139.082 319.402 139.8C324.434 140.518 329.741 139.355 333.335 137.918C336.928 136.481 335.5 142.717 324.204 144.41C331.076 147.14 339.547 147.14 343.69 144.881C347.98 142.541 345.126 153.658 335.782 156.172C326.439 158.687 314.86 158.727 314.86 158.727C314.86 158.727 281.005 207.51 266.418 207.923C251.829 208.336 256.626 189.898 256.626 189.898",
    fill: "#FFC6A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.501 153.834C329.401 153.834 327.396 153.42 325.841 152.467C317.833 147.555 312.864 151.829 312.816 151.873C312.698 151.978 312.514 151.967 312.41 151.849C312.305 151.73 312.316 151.549 312.435 151.443C312.486 151.396 317.773 146.844 326.142 151.978C330.274 154.513 337.783 153.034 341.245 150.121C341.497 149.957 342.636 149.275 343.256 149.664C343.54 149.842 343.654 150.176 343.598 150.656C343.58 150.814 343.45 150.928 343.28 150.908C343.122 150.889 343.009 150.747 343.027 150.589C343.055 150.358 343.027 150.198 342.951 150.15C342.724 150.007 342.012 150.31 341.584 150.582C339.294 152.514 335.248 153.834 331.501 153.834",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.063 149.097C331.379 149.097 329.522 148.555 329.486 148.544C329.334 148.499 329.248 148.339 329.293 148.187C329.34 148.036 329.5 147.948 329.652 147.995C329.72 148.015 336.485 149.98 342.789 146.235C342.89 146.151 344.084 145.235 344.913 145.616C345.324 145.804 345.547 146.249 345.576 146.94C345.582 147.099 345.459 147.233 345.301 147.239C345.153 147.249 345.009 147.123 345.002 146.964C344.989 146.65 344.921 146.251 344.674 146.138C344.285 145.961 343.512 146.393 343.114 146.707C339.917 148.607 336.615 149.097 334.063 149.097",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.989 151.488C330.451 151.488 328.682 151.002 328.644 150.992C328.491 150.949 328.403 150.79 328.446 150.638C328.489 150.485 328.645 150.395 328.801 150.439C328.876 150.461 336.37 152.507 342.578 147.943C342.688 147.872 343.542 147.336 344.149 147.664C344.472 147.84 344.636 148.202 344.636 148.739C344.636 148.898 344.507 149.027 344.348 149.027C344.19 149.027 344.061 148.898 344.061 148.739C344.061 148.525 344.029 148.253 343.875 148.169C343.637 148.04 343.11 148.284 342.905 148.416C339.532 150.895 335.792 151.488 332.989 151.488",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.658 276.733L249.334 485.779C238.762 493.821 223.849 488.234 223.849 488.234L199.071 291.11C198.8 288.95 196.961 287.329 194.784 287.329C192.601 287.329 190.762 288.955 190.494 291.12L166.203 487.855C152.302 492.138 140.779 486.346 140.779 486.346L154.622 275.552C152.828 269.659 155.827 266.68 155.827 266.68L159.323 234.911L229.242 234.709L233.001 268.525C233.001 268.525 234.75 272.393 233.658 276.733",
    fill: "#6297CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.645 179.188C146.645 179.188 147.368 178.073 148.482 176.283C148.941 175.545 150.055 175.23 150.623 174.294C151.242 173.276 152.236 171.493 152.926 170.317C155.535 165.874 158.212 161.927 159.813 157.927C164.19 146.987 167.321 125.042 151.848 125.042C151.848 125.042 140.235 124.047 132.19 145.642C131.684 146.999 130.834 148.763 129.868 150.607C129.121 152.032 127.533 152.123 126.753 153.492C126.252 154.371 126.539 156.589 126.095 157.343C124.887 159.398 123.998 160.834 123.998 160.834C123.998 160.834 136.852 167.564 146.645 179.188",
    fill: "#E5E3EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.309 236.362C190.856 243.223 159.104 236.427 159.104 236.427C153.814 229.594 158.282 218.346 158.282 218.346C153.219 169.261 150.777 125.196 150.777 125.196C150.777 125.196 151.855 124.686 152.926 124.278C154.534 123.666 155.928 123.874 156.904 123.666C158.627 123.299 159.229 123.242 162.1 122.595C165.476 121.835 170.006 121.474 174.838 119.518C175.072 119.423 175.34 119.525 175.483 119.733C176.501 121.21 181.187 126.878 193.163 126.878C203.558 126.878 209.162 121.546 210.629 120.165C210.855 119.951 211.491 119.963 211.706 120.06C213.82 121.015 214.517 121.215 217.849 121.882C224.99 123.31 230.056 123.995 231.111 124.227C232.264 124.48 233.147 124.993 234.324 125.349C234.324 125.349 230.122 187.951 228.956 211.142C228.893 212.388 229.733 214.063 229.683 216.205C229.626 218.554 228.816 219.57 228.816 221.864C228.816 221.864 233.457 230.582 229.309 236.362",
    fill: "#E5E3EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.664 179.801C237.664 179.801 236.736 178.377 235.354 176.162C234.947 175.507 234.087 175.378 233.611 174.6C233.21 173.944 233.024 172.569 232.591 171.847C229.704 167.033 226.464 161.07 224.721 156.714C220.343 145.774 221.013 125.042 232.003 125.042C232.003 125.042 243.616 124.048 251.661 145.643C252.108 146.842 252.825 148.322 253.655 149.876C254.337 151.155 256.073 151.619 256.819 152.881C257.496 154.026 257.185 155.979 257.777 156.928C258.987 158.874 259.879 160.222 259.879 160.222C259.879 160.222 246.821 166.851 237.664 179.801",
    fill: "#E5E3EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.373 187.992C257.337 187.992 257.301 187.989 257.265 187.982C256.97 187.923 256.78 187.637 256.839 187.343C258.102 181.033 267.147 176.545 267.53 176.356C267.804 176.224 268.126 176.336 268.258 176.605C268.39 176.875 268.278 177.2 268.009 177.332C267.92 177.376 259.062 181.774 257.905 187.555C257.854 187.814 257.625 187.992 257.373 187.992",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.067 190.848C126.816 190.848 126.59 190.672 126.536 190.416C124.965 182.962 117.042 177.345 116.963 177.289C116.716 177.117 116.657 176.778 116.829 176.532C117.001 176.287 117.34 176.227 117.586 176.399C117.926 176.637 125.941 182.323 127.6 190.192C127.661 190.486 127.474 190.774 127.18 190.836C127.142 190.844 127.104 190.848 127.067 190.848",
    fill: "#EA967D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.979 253.499C193.768 253.499 193.598 253.328 193.598 253.118V247.816C193.598 247.605 193.768 247.436 193.979 247.436C194.19 247.436 194.36 247.605 194.36 247.816V253.118C194.36 253.328 194.19 253.499 193.979 253.499",
    fill: "#4670B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.116 278.788C193.922 278.788 193.756 278.64 193.738 278.443C193.719 278.234 193.872 278.048 194.082 278.029C194.144 278.023 200.322 277.41 200.47 274.311C200.872 265.852 200.877 247.995 200.877 247.816C200.877 247.606 201.047 247.436 201.258 247.436C201.468 247.436 201.639 247.606 201.639 247.816C201.639 247.996 201.634 265.87 201.23 274.347C201.051 278.102 194.434 278.76 194.152 278.787C194.14 278.787 194.129 278.788 194.116 278.788",
    fill: "#4670B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.978 286.945C193.917 286.945 193.856 286.93 193.799 286.9L175.438 277.111C175.252 277.012 175.182 276.782 175.281 276.596C175.381 276.411 175.613 276.341 175.796 276.439L193.597 285.93V257.808C193.597 257.598 193.768 257.428 193.978 257.428C194.189 257.428 194.36 257.598 194.36 257.808V286.564C194.36 286.698 194.289 286.822 194.174 286.891C194.114 286.926 194.046 286.945 193.978 286.945",
    fill: "#4670B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.063 266.449C232.026 266.449 231.989 266.444 231.951 266.433C224.795 264.24 223.588 246.797 223.54 246.056C223.527 245.846 223.686 245.665 223.896 245.652C224.106 245.635 224.286 245.797 224.301 246.007C224.311 246.183 225.517 263.665 232.175 265.705C232.376 265.767 232.488 265.98 232.427 266.181C232.377 266.344 232.226 266.449 232.063 266.449",
    fill: "#4670B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.826 267.06C155.68 267.06 155.542 266.976 155.478 266.834C155.393 266.643 155.478 266.418 155.671 266.332C162.561 263.255 163.092 247.252 163.096 247.091C163.102 246.884 163.271 246.721 163.477 246.721H163.487C163.697 246.727 163.863 246.902 163.857 247.111C163.838 247.79 163.308 263.755 155.981 267.027C155.931 267.05 155.878 267.06 155.826 267.06",
    fill: "#4670B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.317 131.636C187.735 131.636 182.91 130.601 178.975 128.56C178.824 128.482 178.765 128.297 178.843 128.145C178.923 127.994 179.109 127.936 179.258 128.014C183.105 130.009 187.835 131.021 193.317 131.021C202.745 131.021 208.518 127.172 211.118 124.878C211.245 124.766 211.44 124.777 211.552 124.905C211.664 125.032 211.652 125.226 211.525 125.339C208.859 127.691 202.948 131.636 193.317 131.636",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.792 127.849C177.737 127.849 177.681 127.835 177.632 127.804C176.244 126.955 174.981 125.963 173.879 124.854C173.758 124.734 173.759 124.539 173.88 124.419C174 124.3 174.195 124.3 174.315 124.421C175.383 125.495 176.607 126.456 177.953 127.279C178.098 127.368 178.143 127.557 178.055 127.702C177.997 127.797 177.896 127.849 177.792 127.849",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.296 184.492C230.289 184.492 230.282 184.492 230.275 184.491C230.105 184.479 229.978 184.333 229.989 184.163L232.438 149.493C232.45 149.324 232.589 149.196 232.767 149.208C232.936 149.22 233.063 149.366 233.051 149.536L230.603 184.206C230.591 184.369 230.456 184.492 230.296 184.492",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.609 179.19C154.452 179.19 154.318 179.071 154.303 178.911L151.855 153.215C151.838 153.046 151.963 152.896 152.133 152.879C152.297 152.86 152.451 152.987 152.467 153.156L154.916 178.853C154.932 179.022 154.808 179.172 154.638 179.188C154.629 179.19 154.619 179.19 154.609 179.19",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.981 161.798C249.883 161.798 249.787 161.751 249.727 161.663C249.632 161.523 249.668 161.332 249.808 161.236C252.075 159.699 254.394 158.438 256.702 157.49C256.858 157.425 257.039 157.5 257.103 157.657C257.168 157.815 257.093 157.994 256.936 158.059C254.668 158.991 252.386 160.231 250.154 161.745C250.101 161.781 250.041 161.798 249.981 161.798",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.009 175.825C235.951 175.825 235.892 175.81 235.841 175.776C235.698 175.683 235.658 175.493 235.751 175.35C235.796 175.279 240.459 168.183 248.047 162.495C248.182 162.394 248.374 162.42 248.477 162.556C248.579 162.693 248.552 162.885 248.416 162.987C240.918 168.608 236.313 175.616 236.266 175.686C236.207 175.776 236.109 175.825 236.009 175.825",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.971 175.724C147.879 175.724 147.788 175.682 147.727 175.604C140.504 166.277 126.838 158.324 126.7 158.246C126.554 158.16 126.503 157.973 126.588 157.825C126.673 157.679 126.862 157.628 127.009 157.713C127.147 157.793 140.917 165.806 148.214 175.228C148.319 175.363 148.293 175.556 148.159 175.659C148.103 175.703 148.037 175.724 147.971 175.724",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.56 156.757C233.537 156.757 233.511 156.754 233.487 156.748C233.322 156.708 233.221 156.542 233.261 156.377C236.065 144.768 233.292 134.607 233.264 134.506C233.218 134.342 233.313 134.173 233.477 134.127C233.639 134.08 233.81 134.177 233.856 134.34C233.884 134.443 236.701 144.751 233.859 156.521C233.825 156.662 233.699 156.757 233.56 156.757",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.549 159.408C151.419 159.408 151.298 159.325 151.257 159.194C149.093 152.437 148.595 138.449 148.59 138.309C148.584 138.139 148.718 137.997 148.888 137.991C149.067 137.983 149.199 138.118 149.206 138.288C149.21 138.428 149.705 152.33 151.842 159.007C151.895 159.169 151.805 159.342 151.643 159.394C151.612 159.403 151.581 159.408 151.549 159.408",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.54 195.28C189.722 195.28 178.259 190.651 178.131 190.598C177.974 190.534 177.898 190.354 177.962 190.197C178.027 190.04 178.207 189.965 178.363 190.029C178.505 190.086 192.569 195.765 202.736 194.476C202.903 194.455 203.059 194.574 203.08 194.742C203.101 194.911 202.982 195.065 202.813 195.086C201.756 195.219 200.658 195.28 199.54 195.28",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.072 202.904C186.693 202.904 179.375 202.045 179.253 202.031C179.084 202.011 178.965 201.858 178.985 201.688C179.005 201.52 179.147 201.401 179.327 201.42C179.529 201.444 199.806 203.822 211.443 200.613C211.605 200.567 211.776 200.664 211.822 200.827C211.868 200.992 211.771 201.161 211.607 201.206C206.869 202.512 200.729 202.904 195.072 202.904",
    fill: "#C2C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.293 161.788C313.918 162.283 313.241 162.434 312.684 162.157C310.987 161.308 304.663 157.301 303.451 149.535C303.427 149.381 303.521 149.228 303.635 149.12C304.391 148.409 305.086 147.8 305.555 147.399C305.821 147.171 306.23 147.302 306.315 147.642C306.851 149.784 308.893 155.977 315.051 158.739C315.567 158.97 315.753 159.609 315.455 160.089C315.164 160.56 314.769 161.16 314.293 161.788",
    fill: "#192064"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.565 157.988C310.565 158.262 310.342 158.485 310.067 158.485C309.793 158.485 309.57 158.262 309.57 157.988C309.57 157.713 309.793 157.49 310.067 157.49C310.342 157.49 310.565 157.713 310.565 157.988",
    fill: "#C1C4D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.555 159.328C312.555 159.602 312.333 159.825 312.058 159.825C311.783 159.825 311.561 159.602 311.561 159.328C311.561 159.053 311.783 158.83 312.058 158.83C312.333 158.83 312.555 159.053 312.555 159.328",
    fill: "#C1C4D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.275 244.959C158.275 244.959 193.907 251.414 230.04 244.959C229.734 240.065 229.381 236.361 229.381 236.361C229.381 236.361 199.352 241.319 159.117 236.471C158.636 241.052 158.275 244.959 158.275 244.959",
    fill: "#5C2552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.543 238.79V248.349C184.543 249.2 185.209 249.903 186.059 249.934C190.813 250.108 195.924 250.138 201.318 249.95C202.171 249.92 202.852 249.215 202.852 248.363V238.815C202.852 237.923 202.123 237.211 201.232 237.235C196.588 237.356 191.551 237.365 186.181 237.212C185.289 237.186 184.543 237.897 184.543 238.79",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.717 240.603V246.59C186.717 247.267 187.246 247.825 187.924 247.846C191.485 247.96 195.309 247.98 199.344 247.857C200.023 247.837 200.568 247.276 200.568 246.598V240.62C200.568 239.915 199.996 239.351 199.292 239.367C195.808 239.447 192.033 239.452 188.011 239.352C187.306 239.334 186.717 239.897 186.717 240.603",
    fill: "#5C2552"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.085 232.04H330.951V190.051C330.951 186.709 333.653 184 336.986 184H337.05C340.383 184 343.085 186.709 343.085 190.051V232.04Z",
    fill: "#5BA02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.443 242.248H337.211V220.201C337.211 216.93 339.867 214.277 343.143 214.277H343.511C346.787 214.277 349.443 216.93 349.443 220.201V242.248Z",
    fill: "#92C110"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.244 231.834H319.012V208.002C319.012 204.73 321.657 202.078 324.92 202.078H325.335C328.598 202.078 331.244 204.73 331.244 208.002V231.834Z",
    fill: "#92C110"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.379 267C316.065 267 315 265.986 315 264.734V233.266C315 232.014 316.065 231 317.379 231H350.621C351.935 231 353 232.014 353 233.266V264.734C353 265.986 351.935 267 350.621 267H317.379Z",
    fill: "#CAD5EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.123 193.151C335.123 193.809 334.589 194.341 333.93 194.341C333.271 194.341 332.736 193.809 332.736 193.151C332.736 192.494 333.271 191.961 333.93 191.961C334.589 191.961 335.123 192.494 335.123 193.151",
    fill: "#92C110"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.387 205.35C341.387 206.008 340.852 206.541 340.193 206.541C339.534 206.541 339 206.008 339 205.35C339 204.693 339.534 204.16 340.193 204.16C340.852 204.16 341.387 204.693 341.387 205.35",
    fill: "#92C110"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.891 211.302C322.891 211.959 322.356 212.492 321.697 212.492C321.038 212.492 320.504 211.959 320.504 211.302C320.504 210.644 321.038 210.111 321.697 210.111C322.356 210.111 322.891 210.644 322.891 211.302",
    fill: "#5BA02E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.857 223.501C328.857 224.158 328.323 224.691 327.664 224.691C327.005 224.691 326.471 224.158 326.471 223.501C326.471 222.843 327.005 222.311 327.664 222.311C328.323 222.311 328.857 222.843 328.857 223.501",
    fill: "#5BA02E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.567708
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 360,
    y: 158,
    width: 39,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360 158.111H398.65V167.223H360V158.111Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.549 167.223L394.105 167.211C396.616 167.21 398.651 165.171 398.65 162.659C398.649 160.146 396.613 158.11 394.102 158.111L364.545 158.124C362.034 158.125 359.999 160.163 360 162.676C360.001 165.188 362.037 167.224 364.549 167.223",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 371,
    y: 176,
    width: 39,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.225 176.014H409.913V185.088H371.225V176.014Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.778 185.088L405.364 185.076C407.877 185.075 409.914 183.044 409.913 180.542C409.912 178.04 407.874 176.013 405.36 176.014L375.775 176.026C373.26 176.027 371.223 178.056 371.225 180.559C371.226 183.062 373.265 185.089 375.778 185.088",
    fill: "#E4E6EF"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.309 167.277V167.274L393.882 167.268C391.381 167.269 389.357 169.282 389.358 171.764C389.358 174.245 391.386 176.256 393.885 176.255L378.312 176.262V176.261C380.794 176.238 382.799 174.235 382.798 171.766C382.796 169.298 380.79 167.297 378.309 167.277",
    fill: "#E4E6EF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 267,
    width: 438,
    height: 1,
    fill: "#E5E3EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4138 50.3184L55.2598 86.0217H62.0033L73.1585 50.3184H66.4138Z",
    fill: "#CED0DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 54,
    width: 14,
    height: 29
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 54.5059H51.1594V82.4418H38V54.5059Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5115 54.5059H43.2345H38.6481C38.2901 54.5059 38 54.8004 38 55.1638V59.82V77.1277V81.7839C38 82.1473 38.2901 82.4418 38.6481 82.4418H43.2345H50.5115C50.8695 82.4418 51.1596 82.1473 51.1596 81.7839V77.7857C51.1596 77.4222 50.8695 77.1277 50.5115 77.1277H43.2345V59.82H50.5115C50.8695 59.82 51.1596 59.5255 51.1596 59.1631V55.1638C51.1596 54.8004 50.8695 54.5059 50.5115 54.5059",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 54,
    width: 14,
    height: 29
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7129 54.5059H90.872V82.4418H77.7129V54.5059Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2244 54.5059H85.638H78.361C78.003 54.5059 77.7129 54.8004 77.7129 55.1638V59.1631C77.7129 59.5255 78.003 59.82 78.361 59.82H85.638V77.1277H78.361C78.003 77.1277 77.7129 77.4222 77.7129 77.7857V81.7839C77.7129 82.1473 78.003 82.4418 78.361 82.4418H85.638H90.2244C90.5824 82.4418 90.8725 82.1473 90.8725 81.7839V77.7857V59.1631V55.1638C90.8725 54.8004 90.5824 54.5059 90.2244 54.5059",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 240,
    width: 11,
    height: 10
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.834 240.043H54.773V249.981H44.834V240.043Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7467 245.519C54.4665 248.249 52.0265 250.235 49.2966 249.955C46.5659 249.675 44.5795 247.235 44.8605 244.505C45.1406 241.775 47.5807 239.788 50.3105 240.069C53.0404 240.35 55.0268 242.79 54.7467 245.519",
    fill: "#E4E6EF"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6693 227.323C86.3869 230.068 83.9272 232.065 81.1752 231.784C78.4224 231.502 76.4199 229.048 76.7023 226.303C76.9856 223.558 79.4454 221.56 82.1973 221.843C84.9492 222.124 86.9517 224.578 86.6693 227.323",
    fill: "#E4E6EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9934 225.507C21.7113 228.252 19.2507 230.249 16.4981 229.967C13.7464 229.685 11.7437 227.232 12.0266 224.487C12.3088 221.742 14.7694 219.745 17.5211 220.026C20.2737 220.308 22.2764 222.762 21.9934 225.507",
    fill: "#E4E6EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 232,
    width: 11,
    height: 12
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.027 232.805H114.873V243.528H104.027V232.805Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.845 238.714C114.538 241.659 111.876 243.802 108.897 243.5C105.917 243.197 103.751 240.565 104.056 237.619C104.362 234.673 107.025 232.531 110.004 232.833C112.982 233.136 115.15 235.768 114.845 238.714",
    fill: "#E4E6EF"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.871 245.439L49.7489 245.362L17.4648 224.958L17.7218 224.543L49.8845 244.872L82.4609 226.447L82.5679 226.49L110.378 237.52L110.201 237.973L82.4971 226.986L49.871 245.439Z",
    fill: "#E4E6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 36.4375,
    width: 101.915,
    height: 74.5473,
    rx: 2.97879,
    fill: "#E2E7F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.435 103.57C308.872 103.57 308.416 103.114 308.416 102.551V51.357C308.416 50.7942 308.872 50.3379 309.435 50.3379H371.451C372.013 50.3379 372.47 50.7942 372.47 51.357V102.751C372.47 103.203 372.094 103.57 371.63 103.57H309.435Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.734 90.6489C314.271 90.6489 313.895 90.2822 313.895 89.83V56.567C313.895 56.1146 314.271 55.748 314.734 55.748H366.445C366.909 55.748 367.285 56.1146 367.285 56.567V89.83C367.285 90.2822 366.909 90.6489 366.445 90.6489H314.734Z",
    fill: "#CED7EC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.197 60.5601H317.531C317.248 60.5601 317.018 60.3359 317.018 60.0593C317.018 59.7828 317.248 59.5586 317.531 59.5586H321.197C321.481 59.5586 321.711 59.7828 321.711 60.0593C321.711 60.3359 321.481 60.5601 321.197 60.5601",
    fill: "#B2BED9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.256 62.9624H317.59C317.306 62.9624 317.076 62.7382 317.076 62.4616C317.076 62.1851 317.306 61.9609 317.59 61.9609H321.256C321.54 61.9609 321.77 62.1851 321.77 62.4616C321.77 62.7382 321.54 62.9624 321.256 62.9624",
    fill: "#B2BED9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.895 81.4324C319.451 81.4324 317.976 74.5675 326.391 74.5675C334.807 74.5675 334.368 80.7045 340.932 80.7045C347.598 80.7045 347.157 63.0781 353.543 63.0781C360.283 63.0781 358.762 79.0501 367.158 79.0501V89.8744C367.158 90.3269 366.782 90.6937 366.317 90.6933L314.734 90.65C314.27 90.6496 313.895 90.2831 313.895 89.831L313.895 81.4324Z",
    fill: "#393D65"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M313.705 84.0833C322.101 84.0833 320.911 65.3105 326.322 65.3105C331.477 65.3105 329.929 84.0833 340.603 84.0833C347.166 84.0833 349.231 76.4309 353.867 76.4309C358.504 76.4309 361.602 84.0833 367.158 84.0833",
    stroke: "white",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.457 95.5043H366.25",
    stroke: "#E4E6EF",
    strokeWidth: 0.76436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M314.457 98.9633H357.973",
    stroke: "#E4E6EF",
    strokeWidth: 0.76436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 33H378.134C379.641 33 380.864 34.1916 380.864 35.6616V43.5932H279V35.6616C279 34.1916 280.222 33 281.73 33Z",
    fill: "#393D65"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.835,
    cy: 38.2962,
    rx: 1.94844,
    ry: 1.89973,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.112,
    cy: 38.2962,
    rx: 1.94844,
    ry: 1.89973,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.392,
    cy: 38.2962,
    rx: 1.94844,
    ry: 1.89973,
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M312.837 75.8072L311.584 74.8879L312.837 73.9707L314.091 74.8879L312.837 75.8072V75.8072Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 286.252,
    y: 71.0449,
    width: 14.582,
    height: 3.58985,
    rx: 0.804028,
    fill: "#B2BED9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 286.252,
    y: 77.957,
    width: 14.582,
    height: 3.48117,
    rx: 0.791829,
    fill: "#B2BED9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 286.252,
    y: 84.7266,
    width: 14.582,
    height: 3.48117,
    rx: 0.791829,
    fill: "#B2BED9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.543,
    cy: 58.0859,
    rx: 7.27962,
    ry: 7.09763,
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.543 65.1835C295.641 65.1846 297.632 64.2809 298.982 62.7148C297.919 60.7461 295.824 59.5137 293.542 59.5137C291.26 59.5137 289.165 60.7461 288.102 62.7148C289.452 64.2812 291.444 65.185 293.543 65.1835V65.1835Z",
    fill: "#393D65"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.582,
    cy: 57.1264,
    rx: 2.73782,
    ry: 2.66937,
    fill: "#393D65"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 0,
    width: 60,
    height: 60
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.094 0H410.566V59.3414H351.094V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.094 29.6707C351.094 46.0574 364.407 59.3414 380.83 59.3414C397.252 59.3414 410.566 46.0574 410.566 29.6707C410.566 13.284 397.252 0 380.83 0C364.407 0 351.094 13.284 351.094 29.6707Z",
    fill: "#764ABC"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.492 21.0223C374.492 17.5311 377.328 14.7008 380.825 14.7008C384.322 14.7008 387.158 17.5311 387.158 21.0223V24.19H390.324V21.0243C390.324 15.79 386.073 11.5469 380.83 11.5469H380.83C375.587 11.5469 371.336 15.79 371.336 21.0243V24.19H374.492V21.0223Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6789_88954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 366,
    y: 23,
    width: 30,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.045 23.6543H395.698V43.3524H366.045V23.6543Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6789_88954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.512 43.3524H367.231C366.579 43.3524 366.045 42.8205 366.045 42.1705V24.8362C366.045 24.1861 366.579 23.6543 367.231 23.6543H394.512C395.164 23.6543 395.698 24.1861 395.698 24.8362V42.1705C395.698 42.8205 395.164 43.3524 394.512 43.3524",
    fill: "white"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.059 30.2053C382.059 29.5914 381.546 29.0938 380.914 29.0938C380.281 29.0938 379.769 29.5914 379.769 30.2053V33.8598C379.119 34.2486 378.684 34.9584 378.684 35.7697C378.684 36.9987 379.682 37.995 380.914 37.995C382.145 37.995 383.144 36.9987 383.144 35.7697C383.144 34.9585 382.709 34.2486 382.059 33.8598V30.2053Z",
    fill: "#764ABC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.ec93716c0a0725b8f104f9737490dd15.svg";
export { ForwardRef as ReactComponent };